/**
 * Creates a dictionary (index) of objects based on a specified property.
 *
 * @param arrayOfObjects - An array of objects to index.
 * @param identifier - The property to use as the index key.
 * @returns {Record<string, any>} - A dictionary of objects indexed by the specified property.
 */
export function buildLookupObject(
  arrayOfObjects: Array<Record<string, any>>,
  identifier: string,
): Record<string, any> {
  // Initialize an empty dictionary to store the indexed objects.
  const finalObject: Record<string, any> = {};

  // Iterate through each object in the array.
  for (const object of arrayOfObjects) {
    // Add a new entry to the dictionary using the property value as the key.
    finalObject[object[identifier]] = object;
  }

  return finalObject;
}
